// components/DeliveryRoutesList.js
import React from 'react';

const DeliveryRoutesList = ({ routes, onEdit }) => {
  return (
    <div className="max-w-6xl bg-white rounded shadow p-6 mx-auto">
      <h2 className="text-xl font-semibold mb-4">Delivery Routes</h2>
      <table className="min-w-full table-auto border">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">Route Name</th>
            <th className="px-4 py-2 text-left">Contact Name</th>
            <th className="px-4 py-2 text-left">Contact Mobile</th>
            <th className="px-4 py-2 text-left">Vehicle No.</th>
            <th className="px-4 py-2 text-left">Pod Name</th>
          </tr>
        </thead>
        <tbody>
          {routes.map((route) => (
            <tr
              key={route.id}
              className="border-t hover:bg-gray-50 cursor-pointer"
              onClick={() => onEdit(route)}
            >
              <td className="px-4 py-2">{route.routename}</td>
              <td className="px-4 py-2">{route.deliverycontactname}</td>
              <td className="px-4 py-2">{route.deliverycontactmobile}</td>
              <td className="px-4 py-2">{route.vechiclenumber}</td>
              <td className="px-4 py-2">{route.pod?.podname || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DeliveryRoutesList;